import * as React from "react";
import styled from "styled-components";

export type StepState = "completed" | "active" | "inactive";

export function Steps({steps}: { steps: StepState[] }) {
    return <Container className="flex flex-row items-center justify-center gap-4 mb-4">
        {steps.map((step, index) => <>
            {index > 0 && <span key={`divider-${index}`} className="step-divider">—</span>}
            <span key={index} className={`step-number ${step}`}>{index + 1}</span>
        </>)}
    </Container>
}

const Container = styled.div`
    .step-number {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        font-weight: bold;
        font-size: 1.125rem;
        border: 2px solid rgba(255, 255, 255, 0.3);
        color: rgba(255, 255, 255, 0.5);
        background: rgba(255, 255, 255, 0.1);
    }

    .step-number.active {
        background: #ffc107;
        color: #000;
        border-color: #ffc107;
        box-shadow: 0 0 15px rgba(255, 193, 7, 0.5);
    }

    .step-number.completed {
        background: #22c55e;
        color: #fff;
        border-color: #22c55e;
    }

    .step-divider {
        color: rgba(255, 255, 255, 0.5);
        font-size: 1.5rem;
        font-weight: bold;
    }
`;